import axios from "axios";
import {getAppLang, getProperty, getUserToken, isDefined} from "../../../../utils";
import {BOOKING_NOTIFICATIONS} from "../../../../constants/api.constants";
import {
    bookingNotificationConstants,
    BOOKING_NOTIFICATION_MAX_FAILURES,
    BOOKING_NOTIFICATION_TIMEOUT_MS,
} from "../../../../constants/Booking/bookingNotification.constants";

const requestHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

/**
 * Bildirimleri yoklar.
 *
 * Cursor (`after_id`) davranisi — belgedeki en kritik nokta:
 *   `after_id` HIC gonderilmezse servis { latest_id, count: 0, items: [] } doner.
 *   Bu ilk cagri modudur; gecmis yigin bildirim olarak patlamasin diye boyle.
 *   `after_id: 0` ise MESRU bir cursor'dur ve "bastan izle" demektir (tum gecmis).
 *   Bu yuzden cursor yokken alan tamamen disarida birakilir, 0 gonderilmez.
 */
export function getBookingNotifications(force) {

    return (dispatch, getState) => {

        const state = getState().bookingNotificationReducer;

        // Yavas ag / uzun istek durumunda ustuste yoklama yapma.
        if (state.fetching) {
            return Promise.resolve();
        }

        // Devre kesici: kalici hatada (yetki, kesinti) sonsuza kadar yoklamayalim.
        // Panelin "Tekrar dene" / yenile butonu force ile devreyi tekrar acar.
        if (!force && state.failures >= BOOKING_NOTIFICATION_MAX_FAILURES) {
            return Promise.resolve();
        }

        // Tesis secilmeden bildirim baglami yok. Bu koruma olmadan /app'te
        // (ilk giriste property_id henuz yazilmamisken) servise bos bir
        // {"params":{}} govdesi gidiyordu.
        const propertyId = getProperty();

        if (!isDefined(propertyId)) {
            return Promise.resolve();
        }

        const params = {
            property_id: Number(propertyId),
        };

        if (state.cursor !== null && state.cursor !== undefined) {
            params.after_id = state.cursor;
        }

        const promise = dispatch({
            type: 'BOOKING_NOTIFICATIONS',
            payload: axios.post(BOOKING_NOTIFICATIONS, {params: params}, {
                headers: requestHeaders(),
                timeout: BOOKING_NOTIFICATION_TIMEOUT_MS,
            }).then(response => response.data),
            meta: {propertyId: String(propertyId)},
        });

        // Poller arka planda calisiyor; ag hatasi konsolu "unhandled rejection"
        // ile doldurmasin. Hata zaten REJECTED ile store'a dusuyor.
        return promise && typeof promise.catch === 'function'
            ? promise.catch(() => {})
            : promise;
    }
}

/**
 * "Gorulmus" isaretle. Belgedeki tuzak: bunu menu ACILINCA yaparsaniz ayni anda
 * donen yoklama count:0 dondurur ve liste kullanicinin gozu onunde bosalir.
 * Bu yuzden yalnizca menu KAPANINCA cagrilir.
 */
export function markBookingNotificationsSeen() {
    return {type: bookingNotificationConstants.BOOKING_NOTIFICATIONS_MARK_SEEN};
}

export function clearBookingNotificationToast() {
    return {type: bookingNotificationConstants.BOOKING_NOTIFICATIONS_TOAST_CLEAR};
}

export function resetBookingNotifications() {
    return {type: bookingNotificationConstants.BOOKING_NOTIFICATIONS_RESET};
}
